// @ts-nocheck
import { httpClient } from '../../../core/network';

class ActivityService {
  static fetchActivities(customerId) {
    const apiUrl = `/activities/${customerId}`;
    return httpClient.get(apiUrl);
  }
}

export default ActivityService;
